import { HttpClient } from '../../../ky/HttpClient';
import { GameDto } from '../../../dto/GameDto';

const getAllGames = async (): Promise<GameDto[]> => {
  return await HttpClient.get('games/all').json();
};

export { getAllGames };
